import { useIsAuthenticated } from "@azure/msal-react";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

function PlainLayout() {
    const location = useLocation();
    const isAuthenticated = useIsAuthenticated();
    const navigate = useNavigate();

    useEffect(() => {
        if(process.env.REACT_APP_NODE_ENV === "QA") {
            return;
        }
        if (isAuthenticated) {
            navigate('/')
        }
    }, [isAuthenticated])

    return (
        <div className={`plainlayout ${location.pathname !== "/" ? "mainlayout" : ""}`}>
            <div className="mainroute">
                <Outlet />
            </div>
        </div>
    );
}

export default PlainLayout;